import mobileUpgradeBase64 from '../../../../assets/base64/mobile-upgrade.js';
import mobileStarBase64 from '../../../../assets/base64/cion.js';
import AiIconIcon from '../../../../assets/svg/mobile-ai.svg?react';
import CalendarIcon from '../../../../assets/svg/mobile-calendar.svg?react';
import PayIcon from '../../../../assets/svg/mobile-pay.svg?react';
import CloseIcon from '../../../../assets/svg/mobile-close.svg?react';
import FJIconButton from '../../../../common/components/FJIconButton/FJIconButton.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import styles from './FJMobileUpgradeModal.module.less';
import PropTypes from 'prop-types';

const infoList = [
    { text: 'credits-can-be-used-for-all-flexClip-ai-features', icon: <AiIconIcon className={styles.info_icon} /> },
    { text: 'valid-for-365-days-from-the-date-of-purchase', icon: <CalendarIcon className={styles.info_icon} /> },
    { text: 'one-time-payment', icon: <PayIcon className={styles.info_icon} /> },
];
const FJMobileUpgradeModal = props => {
    const { onUpgrade, onClose } = props;
    return (
        <div className={styles.box} style={{ backgroundImage: `url(${mobileUpgradeBase64})` }}>
            <div className={styles.close} onClick={onClose}>
                <CloseIcon />
            </div>
            <div className={styles.title}>{FJLocalStore._('purchase-credits-to-enjoy-ai-features')}</div>
            {infoList.map((info, index) => (
                <div className={styles.info_box} key={index}>
                    {info.icon}
                    <span className={styles.info_text}>{FJLocalStore._(info.text)}</span>
                </div>
            ))}
            <FJIconButton
                text={FJLocalStore._('get-credits')}
                onClick={onUpgrade}
                icon={<img className={styles.btn_icon} src={mobileStarBase64} />}
                className={styles.btn}
                textClassName={styles.btn_text}
            />
        </div>
    );
};
FJMobileUpgradeModal.propTypes = {
    onClose: PropTypes.func,
    onUpgrade: PropTypes.func,
};
export default FJMobileUpgradeModal;
